import type { ListingList } from "../../post/types";

// The numbers mirror the listing page's MLS Open House Sync dialog (listings/listing/OpenHousePosts.tsx); change both together.
export const SYNC_ON_NOTE = "Your campaign posts already pick up open houses from the MLS. Marabot looks for open houses within 10 days of each post date, includes up to 4 upcoming ones (5 when a Saturday and Sunday pair), and moves the call to action to the top. Use this card for an extra post about a specific open house.";
export const SYNC_OFF_NOTE = "This listing's campaign has MLS Open House Sync off, so open houses are only posted when you create them here.";

/** Where the sync-off note sends the user to turn the sync on. */
export type SyncOffLink = "campaign-settings" | "autopilot-settings" | "none";
export type OpenHouseNote =
    | { kind: "sync-on" | "none"; text: string }
    | { kind: "sync-off"; text: string; link: SyncOffLink };

/**
 * The listing page offers Edit Campaign Settings only for an ACTIVE campaign that Auto Pilot does not manage. An
 * Auto Pilot campaign takes the sync from Auto Pilot settings (whatever its status); another campaign that is not
 * ACTIVE cannot be edited, so no link. Both fields absent (an older api) keeps the campaign settings link.
 */
function syncOffLink(listing: ListingList): SyncOffLink {
    if (listing.managedByAutopilot === true) return "autopilot-settings";
    if (listing.campaignStatus !== undefined && listing.campaignStatus !== "ACTIVE") return "none";
    return "campaign-settings";
}

/** The note under the Open House card's picker: MLS rows only (the sync reads the MLS), none for Rentcast. */
export function openHouseNote(listing: ListingList | undefined): OpenHouseNote {
    // Matched as the picker matches a property row: whatever the spacing and case.
    if (!listing || (listing.listingType ?? "").toLowerCase().replace(/\s/g, "") !== "mlslisting") return { kind: "none", text: "" };
    // Only an explicit true means the sync runs: the campaign schema defaults the flag to false and
    // the sync itself treats a missing flag as off, so an older campaign's open houses are NOT picked up.
    return listing.openHouseMonitoring === true
        ? { kind: "sync-on", text: SYNC_ON_NOTE }
        : { kind: "sync-off", text: SYNC_OFF_NOTE, link: syncOffLink(listing) };
}
